import Actualites from "./Actualites";

export default Actualites;
